<script>
    export let recommendation;
    export let added_recommendations;
</script>
<tr class:added={added_recommendations.has(recommendation._id)}>
    <td class="function is-v-centered is-h-centered" data-field={recommendation.function}>{recommendation.function}</td>
    <td class="is-v-centered is-h-centered">{recommendation.category}</td>
    <td>{recommendation.finding}</td>
    <td class="risk is-v-centered is-h-centered" data-field={recommendation.probability}>{recommendation.probability}</td>
    <td class="risk is-v-centered is-h-centered" data-field={recommendation.impact}>{recommendation.impact}</td>
    <td class="risk is-v-centered is-h-centered" data-field={recommendation.overall}>{recommendation.overall}</td>
    <td>{recommendation.recommendation}</td>
    <td class="risk is-v-centered is-h-centered">
        <slot></slot>
    </td>
</tr>

<style>
    .added {
        background-color: lightgray;
    }
</style>